<template>
    <div class="autocomplete__container">
        <p v-if="title">{{ title }}</p>
        <input
            :value="modelValue" 
            :placeholder="placeholder" 
            @input="input($event)"
            :disabled="disabled"
        />
        <div v-if="listShow" class="autocomplete__items">
            <div v-for="(item, index) in items" :key="item.id"
                @click="selectCurrentItem(item)"
            >
                {{ item.label }}
            </div>
        </div>
        <span v-if="error">{{ error }}</span>

        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            modelValue: String,
            items: Array,
            placeholder: String,
            disabled: Boolean,
            title: String,
            error: String,
        },
        emits: ['update:modelValue', 'autoInput', 'itemSelected'],
        data() {
            return {
                listShow: false,
            }
        },
        methods: {
            input(e) {
                this.listShow = true
                this.$emit('update:modelValue', e.target.value)
                this.$emit('autoInput')
            },
            selectCurrentItem(item) {
                this.listShow = false
                this.$emit('update:modelValue', item.label)
                this.$emit('itemSelected', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.autocomplete {
    &__container {
        position: relative;
        display: flex;
        flex-direction: column;

        input {
            width: 100%;
            appearance: none;

            &:disabled {
                background-color: transparent;
            }
        }
    }

    &__items {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        overflow: auto;
        z-index: 1;
        
        div {
            cursor: pointer;
            white-space: pre;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}


</style>